import { render } from "./PinnedNotice.vue?vue&type=template&id=1f088052&scoped=true"
const script = {}

import "./PinnedNotice.vue?vue&type=style&index=0&id=1f088052&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f088052"]])

export default __exports__